import { BLOCK_REP, REP_LIST_FETCH, REP_LIST_UPDATE, SEARCH_REP, UNBLOCK_REP, ACTIVATE_REP } from '../constants/repTypes';
import { normalize } from 'normalizr';
import { repSchema } from '../schemas/Normalizr';

export function repListFetch() {
  return {
    type: REP_LIST_FETCH
  };
}

export function searchRep(query) {
  return {
    type: SEARCH_REP,
    payload: { query }
  };
}

export function updateRep(rep) {
  return {
    type: REP_LIST_UPDATE,
    payload: {
      normalized: normalize(rep, repSchema)
    }
  };
}

export function blockRep(id) {
  return {
    type: BLOCK_REP,
    payload: { id }
  };
}

export function unblockRep(id) {
  return {
    type: UNBLOCK_REP,
    payload: { id }
  };
}

export function activateRep(id) {
  return {
    type: ACTIVATE_REP,
    payload: { id }
  };
}



// WEBPACK FOOTER //
// ./app/actions/repActions.js